import { GameConfigs } from '../../lib/globals/GameConfigs';
import { InfoBox } from '../InfoStyled';
import {
	BONUS_DESC_1,
	BONUS_DESC_2,
	PROGRESSIVE,
	PROGRESSIVE_DESC_1,
	PROGRESSIVE_DESC_2,
	TEXTS,
	WILDS
} from '../helpers/content';
import Bonus from './BonusGame';
import Features from './Features';
import GameInterface from './GameInterface';
import Keyboard from './KeyBoard';
import Paylines from './Paylines';
import Quest from './Quest';
import Specifications from './Specifications';
import SymbolPayout from './SymbolPayout';

export default function Main({
	dimentions,
	coefs,
	currentBet,
	currency,
	currAbr,
	fast
}) {
	return (
		<InfoBox dimentions={dimentions}>
			<SymbolPayout
				className='content'
				dimentions={dimentions}
				coefs={coefs}
				currentBet={currentBet}
				slice={{ a: 2, b: coefs.coeffs.length }}
				currency={currency}
				name='symbols'
				text={TEXTS.symbols}
			/>
			<SymbolPayout
				className='content'
				dimentions={dimentions}
				coefs={coefs}
				currentBet={currentBet}
				slice={{ a: 0, b: 2 }}
				currency={currency}
				name='additional_symbols'
				text={TEXTS.additional_symbols}
			/>
			<Paylines dimentions={dimentions} />
			<Features
				dimentions={dimentions}
				config={coefs}
				currency={currency}
				currentBet={currentBet}
			/>
			<Bonus
				dimentions={dimentions}
				text={[BONUS_DESC_1(coefs.minfs), BONUS_DESC_2()]}
				arr={WILDS}
				title={'BONUS GAME'}
			/>
			<Bonus
				dimentions={dimentions}
				text={[PROGRESSIVE_DESC_1(), PROGRESSIVE_DESC_2()]}
				arr={PROGRESSIVE}
				title={'PROGRESSIVE BONUS GAMEPLAY'}
				className={'progressive'}
			/>
			{GameConfigs.config.hasquest ? <Quest dimentions={dimentions} /> : null}
			<GameInterface
				dimentions={dimentions}
				currency={currency}
				currentBet={currentBet}
				currAbr={currAbr}
				fast={fast}
			/>
			<Keyboard dimentions={dimentions} />
			<Specifications
				dimentions={dimentions}
				config={GameConfigs.config}
				coefs={coefs.bet_steps}
				currency={currency}
			/>
			<div style={{ height: '60px' }} />
		</InfoBox>
	);
}
